import React, { useMemo } from 'react';
import { AboutSection } from '../sections/AboutSection';
import { GoalsSection } from '../sections/GoalsSection';
import { CreatorsSection } from '../sections/CreatorsSection';
import { ContentSection } from '../sections/ContentSection';
import { CompensationSection } from '../sections/CompensationSection';
import { useInitializeCampaign } from '../hooks/useInitializeCampaign';
import { TProject } from '../../types';
import { SaveCampaignCTA } from '../components/SaveCampaignCTA';
import { SidebarLayout } from '../../SettingsPage/components/SidebarLayout';

interface Props {
  activeSection?: string;
  mode?: 'add' | 'edit';
  project?: TProject;
  onSave?: () => void;
  refetchProjects?: () => void;
}

export const SetupTab: React.FC<Props> = ({
  activeSection = 'about',
  mode = 'edit',
  project,
  onSave,
  refetchProjects,
}) => {
  // Initialize campaign data
  useInitializeCampaign(mode, project);

  const sections = useMemo(() => [
    { id: 'about', label: 'About', component: <AboutSection project={project} /> },
    { id: 'goals', label: 'Goals', component: <GoalsSection /> },
    { id: 'creators', label: 'Creators', component: <CreatorsSection /> },
    { id: 'content', label: 'Content', component: <ContentSection /> },
    { id: 'compensation', label: 'Compensation', component: <CompensationSection /> },
  ], [project]);

  return (
    <SidebarLayout
      sections={sections}
      activeSectionId={activeSection}
      header={<SaveCampaignCTA
        mode={mode}
        project={project}
        onSave={onSave}
        refetchProjects={refetchProjects}
        title="Campaign Setup"
      />}
    />
  );
};
